export default __webpack_public_path__ + "static/media/BankerMascot.24dd7bf2.png";